import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { logout } from "./api";
import { meQuery } from "./queries";

/** Sign out: drop the session cookie and everything cached for the user, back to the landing. */
export function useLogout() {
	const queryClient = useQueryClient();
	const navigate = useNavigate();
	return useMutation({
		mutationFn: logout,
		onSettled: async () => {
			// set, not clear(): the mounted headers and landing follow the cached user
			queryClient.setQueryData(meQuery().queryKey, null);
			// cached products carry presigned URLs: none survives the session
			queryClient.removeQueries({ queryKey: ["products"] });
			await navigate({ to: "/" });
		},
	});
}
